import { createSelector } from "reselect";

const rootGemeinde = (state) => state.gemeinde;

export const selectGemeinde = createSelector(
  [rootGemeinde],
  (gemeinde) => gemeinde.gemeinde
);
export const selectErntehelfer = createSelector(
  [rootGemeinde],
  (gemeinde) => gemeinde.erntehelfer
);
export const selectGemeindeliste = createSelector(
  [rootGemeinde],
  (gemeinde) => gemeinde.gemeindeliste
);
export const selectGemeindeDataIsLoading = createSelector(
  [rootGemeinde],
  (gemeinde) => gemeinde.loading
);
